import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  Renderer2,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { DashboardService } from 'src/app/services/dashboard.service';
import { IntroductionDetails } from 'src/app/core/enum';
import { AllBaniInfo, Footnotes } from 'src/app/core/models';
import { first } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import {
  AllBaniData,
} from 'src/app/core/models';
@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IntroductionComponent implements OnInit {
  @ViewChildren('show-footnote-icon') footnoteElements?: QueryList<ElementRef>;
  isHandsetPortrait: boolean = false;
  visible:boolean = false;
  isVisibleShare:boolean = false;
  baniId: string | null = '';
  shareUrl: string | null = '';
  baniInfo?: any = {} as AllBaniInfo;
  baniName?: string;
  introductionParam: string | null = '';
  introductionParamDataPreParsed: string = '';
  introductionParamData: SafeHtml = '';
  previous: string = '';
  next: string = '';
  section: number = 0;
  nextSectionSequence: number = 0;
  fontSize: any = 16;
  isBaniIntroductionParameterLoading: boolean = false;
  allFootnotes: Footnotes[] = [];
  isBaniDataLoading: boolean = false;
  allBaniDashboardData: AllBaniData = {} as AllBaniData;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private storage: StorageService,
    private renderer: Renderer2,
  ) {
    route.params.subscribe(() => {
      this.fetchAndSetBaniData();
    });

    let currentFontSize = localStorage.getItem('fontSize');
    //console.log(currentFontSize);
    if(currentFontSize){
      this.fontSize = currentFontSize;
    }

  }

  ngOnInit(): void {
    this.fetchAndSetBaniData();
    this.shareUrl = location.origin + this.router.url;
  }




  /**
   * request to fetch footnotes by baniId and sectionId
   * section will always be 0 on the Introduction page
   * @param section number = 0
   */
  fetchBaniFootnotes(section: number = 0) {
    this.dashboardService
      .fetchBaniFootnotes(this.baniId, section)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          if (res?.value?.length) this.allFootnotes = res.value;
          this.setFootnotesData(this.introductionParamDataPreParsed);
        },
        error: (err: any) => {
          console.log('error in fetching bani footnotes');
        },
      });
  }

  /**
   * get params from the url and make requests
   */
  fetchAndSetBaniData(): void {
    this.baniId = this.route.snapshot.paramMap.get('baniId');

    this.introductionParam =
      this.route.snapshot.paramMap.get('introductionParam');

    this.fetchBaniIntroduction(Number(this.baniId));
  }

  setFootnotesData(htmlString: string) {
    let paragraph: any = htmlString.slice();
    let modifiedHTML = htmlString.slice();

    modifiedHTML = modifiedHTML.replace(/\r\n\r/g, '\r\r');
    modifiedHTML = modifiedHTML.replace(/\r/g, '<br>');

    // Extracting values and creating an array of objects
    var tagRegex =
      /<bani:\s*(.*?)\s*&\s*section:\s*(.*?)\s*&\s*footnote:\s*(.*?)>/g;
    var tagObjects = [];
    var match;
    // while ((match = tagRegex.exec(modifiedParagraph)) !== null) {
    while ((match = tagRegex.exec(paragraph)) !== null) {
      var bani = match[1];
      var section = match[2];
      var footnote = match[3];

      let tooltipTextData: any = this.allFootnotes.find((footnoteData) => {
        return (
          footnoteData.SectionId == section &&
          footnoteData.BaniId == this.baniId &&
          footnoteData.FootNoteId == +footnote
        );
      });

      modifiedHTML = modifiedHTML.replace(
        `<bani:${bani} & section:${section} & footnote:${footnote}>`,
        `<div class="tooltip1">  <img alt="Bani Footnote" bani="${bani}" section="${section}" footnote="${footnote}" class=\'show-footnote-icon\' src=\'/assets/images/edit-icon-16.png\' >
        <span class="tooltiptext v">${tooltipTextData?.FootNoteContent}</span>
      </div> `
      );

      tagObjects.push({ bani, section, footnote });
    }

    // Displaying the modified paragraph and the array of objects
    this.introductionParamData =
      this.sanitizer.bypassSecurityTrustHtml(modifiedHTML);
  }

  removeAllOtherTooltips() {
    const elements =
      this.elementRef.nativeElement.querySelectorAll('.is-visible');

    elements.forEach((element: any) => {
      this.renderer.removeClass(element, 'is-visible');
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    // Check if the clicked element is a parent element
    if (target.classList.contains('show-footnote-icon')) {
      // Find the child element within the parent
      // const childElement = target.querySelector('.tooltiptext');
      const parentElement = target.parentElement;

      const childElement = parentElement?.querySelector('.tooltiptext');
      // Toggle the class on the child element
      if (childElement) {
        this.removeAllOtherTooltips();
        this.renderer.addClass(childElement, 'is-visible');
        const leftPos = target.getBoundingClientRect().left;
       const tooltipWidth = 240 // tootltip width is 240px
       const innerWidth = window.innerWidth > 1280 ? 1280 : window.innerWidth;
       if(leftPos + tooltipWidth > innerWidth){
        let right = '0px'
       if(tooltipWidth > leftPos){
        right = `${leftPos -tooltipWidth}px`
       }
        this.renderer.setStyle(childElement,'right',right)
       }
       else{
        this.renderer.removeStyle(childElement,'right');
       }
      }
    } else {
      // Remove the class from all child elements
      const childElements =
        this.elementRef.nativeElement.querySelectorAll('.tooltiptext');
      childElements.forEach((childElement: any) => {
        this.renderer.removeClass(childElement, 'is-visible');
      });
    }
  }

  /**
   * request to fetch introduction data by BaniID
   * @param baniId number
   */
  fetchBaniIntroduction(baniId: number): void {
    this.isBaniIntroductionParameterLoading = true;
    this.dashboardService
      .fetchBaniIntroductionData(baniId)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          if (res?.value?.length) {
            this.isBaniIntroductionParameterLoading = false;
            this.baniInfo = res.value[0];

            this.setPreviousAndNextLinks();

            if (this.introductionParam) {
              this.introductionParamDataPreParsed =
                this.baniInfo[this.introductionParam];
            }

            this.fetchBaniFootnotes();
            this.fetchBaniDashboardData(this.baniInfo.BaniCode);
          }
        },
        error: () => {
          console.log('error in fetching bani introduction');
        },
      });
  }

  // check if it exists in the object
  // then provide the corresponding label
  setPreviousAndNextLinks(): void {
    switch (this.introductionParam) {
      case IntroductionDetails.Introduction:
        this.previous = '';
        this.next = this.baniInfo.HistoricalDimension
          ? IntroductionDetails.HistoricalDimension
          : false || this.baniInfo.MusicalDimension
          ? IntroductionDetails.MusicalDimension
          : '' || this.baniInfo.CulturalDimension
          ? IntroductionDetails.CulturalDimension
          : '';
        break;

      case IntroductionDetails.HistoricalDimension:
        this.previous = this.baniInfo.Introduction
          ? IntroductionDetails.Introduction
          : '';
        this.next = this.baniInfo.MusicalDimension
          ? IntroductionDetails.MusicalDimension
          : false || this.baniInfo.CulturalDimension
          ? IntroductionDetails.CulturalDimension
          : '';
        break;

      case IntroductionDetails.MusicalDimension:
        this.previous = this.baniInfo.HistoricalDimension
          ? IntroductionDetails.HistoricalDimension
          : '';
        this.next = this.baniInfo.CulturalDimension
          ? IntroductionDetails.CulturalDimension
          : false || this.baniInfo.SignificantTerms
          ? IntroductionDetails.SignificantTerms
          : '';
        break;

      case IntroductionDetails.CulturalDimension:
        this.previous = IntroductionDetails.MusicalDimension;
        this.next = '';
        break;

      case IntroductionDetails.SignificantTerms:
        this.previous = IntroductionDetails.MusicalDimension;
        this.next = '';
        break;
    }
  }

  handlePrevious(): void {
    window.scrollTo(0, 0);
    if (this.previous)
      this.router.navigate(['/bani/introduction/', this.baniId, this.previous]);
  }

  handleNext(): void {
    window.scrollTo(0, 0);
    //console.log(this.next);
    if (this.next){
      this.router.navigate(['/bani/introduction/', this.baniId, this.next]);
    }else{
      this.router.navigate(['/bani/details/', this.baniInfo.BaniCode,this.nextSectionSequence,2]);
    }
  }

  goToIntroduction(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.Introduction,
    ]);
  }

  goToBani(): void {
    this.router.navigate(['/bani', this.baniInfo.BaniCode]);
  }

  goToHistoricalDimension(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.HistoricalDimension,
    ]);
  }

  goToMusicalDimension(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.MusicalDimension,
    ]);
  }

  goToCulturalDimension(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.CulturalDimension,
    ]);
  }

  goToSignificantTerms(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.SignificantTerms,
    ]);
  }

  /**
   * Gets introduction param label
   * TODO: make i18n method for labels
   */
  get introductionParamLabel() {
    let stringLabel = '';
    let baniLanguage = localStorage.getItem('language');
    switch (this.introductionParam) {
      case IntroductionDetails.Introduction:
        stringLabel = baniLanguage === 'en' ? 'Introduction' : 'ਜਾਣ-ਪਛਾਣ';
        break;
      case IntroductionDetails.HistoricalDimension:
        stringLabel =
          baniLanguage === 'en' ? 'Historical Dimension' : 'ਇਤਿਹਾਸਕ ਪਖ';
        break;
      case IntroductionDetails.CulturalDimension:
        stringLabel =
          baniLanguage === 'en' ? 'Cultural Dimension' : 'Cultural Dimension';
        break;
      case IntroductionDetails.MusicalDimension:
        stringLabel = baniLanguage === 'en' ? 'Musical Dimension' : 'ਸੰਗੀਤਕ ਪਖ';
        break;
      case IntroductionDetails.SignificantTerms:
        stringLabel = baniLanguage === 'en' ? 'Significant Terms' : 'ਮਹੱਤਵਪੂਰਨ ਨਿਯਮ';
        break;  
    }
    return stringLabel;
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  handleIconClick(
    event: any,
    bani: number,
    section: number,
    footnote: number
  ) {}

  showFontList(){

    this.isVisibleShare = false;
    if(this.visible == true){

      this.visible = false;

    }else{

      this.visible = true;

    }
  }
  showShareList(){

    this.visible = false;
    if(this.isVisibleShare == true){

      this.isVisibleShare = false;

    }else{

      this.isVisibleShare = true;

    }
  }

  setFont(size:any){
    
    this.storage.set('fontSize', size);
    this.fontSize = size;
    this.visible = false;
  }

  getBackgroundImageUrl(img:string): any{
      //img= typeof img === 'string' ? img.trim() : '';
      img = img?.trim() || '';
      if(img != ''){
        return `url('${img}')`;
      }else{
        let imgUrl = '/assets/images/carousel-background.webp';
        return `url(${imgUrl})`;
      } 
    
  }

    //Get next page details for navigation
  fetchBaniDashboardData(baniCode: string | null) {
    //console.log(baniCode);
    this.isBaniDataLoading = true;
    this.dashboardService
      .fetchBaniDashboardData(baniCode)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.isBaniDataLoading = false;
          this.allBaniDashboardData = res?.value?.length ? res.value[0] : {};

          // sort sections in descreasing increasing order by SectionSequence
          this.allBaniDashboardData.Sections =
            this.allBaniDashboardData.Sections.sort(
              (a: any, b: any) =>
                parseFloat(a.SectionSequence) - parseFloat(b.SectionSequence)
            );

            this.nextSectionSequence = this.allBaniDashboardData.Sections[0].SectionSequence;

            // console.log(this.nextSectionSequence);
          //this.baniIntroduction = this.allBaniDashboardData.Introduction;
        },
        error: (err) => {
          console.log('error in fetching bani dashboard data ', err);
        },
      });
    }

    fetchLanguage(): string | null {
      return this.storage.get('language');
    }

}
